import {Directive, HostBinding, ViewChild} from "@angular/core";
import {SearchPageComponent} from "./search-page.component";
import {ExtendedSearchParams, SearchType} from "./extended-search-params";
import {SearchFormComponent} from "../search-form/search-form.component";

@Directive()
export abstract class AbstractSearchPage {
    @ViewChild(SearchPageComponent, {static: true}) searchPageComponent: SearchPageComponent;
    @ViewChild(SearchFormComponent, {static: true}) searchFormComponent: SearchFormComponent;
    @HostBinding("style.display") private display: string = "flex";
    @HostBinding("style.width") private width: string = "100%";

    isSelectMode(): boolean {
        return this.searchPageComponent.isSelectMode && this.extendedSearchParams.searchType !== SearchType.NO_SELECTION;
    }

    get extendedSearchParams(): ExtendedSearchParams {
        return this.searchPageComponent.extendedSearchParams;
    }
}
